import React from "react";
import PropTypes from "prop-types";

import { Icon } from "semantic-ui-react";

export function Header({ onClose }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "1em",
        marginRight: "1em",
      }}
    >
      <Icon
        name="x"
        size="large"
        link
        fitted
        onClick={onClose}
        data-test="template-modal-close"
      />
    </div>
  );
}

Header.propTypes = {
  onClose: PropTypes.func,
};

Header.defaultProps = {
  onClose: () => {},
};

export default Header;
